const digest = 'de87087581b9891e2f9c017198cb7d74443cce2a4373c8ec054428cefe765ea3';
const css = `._main-container_1yjpn_1{align-items:center;display:flex;flex-direction:column;gap:1rem;height:100vh;justify-content:center;width:100vw}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'main-container': '_main-container_1yjpn_1' };

export { css, digest };